import { z } from "zod/mini";
import type { $ZodErrorMap } from "zod/v4/core";
import enLocale from "zod/v4/locales/en.js";

const zodErrorMap: $ZodErrorMap = (issue) => {
    if (issue.code === "invalid_type") {
        return "Required";
    }

    if (issue.code === "too_small" && issue.origin === "string" && issue.minimum === 1) {
        return "Required";
    }

    if (issue.code === "invalid_value") {
        return "Required";
    }

    return undefined;
};

z.config({
    ...enLocale(),
    customError: zodErrorMap,
});
